import { type EditorSDK } from '@wix/editor-platform-sdk-types';
import { FormAppPreset } from '../templates/templates';
import { readConfig } from '../config/config';
import { FORM_APP_DEF_ID } from '../constants/app';

export const getUninitializedComponents = async (
  sdk: EditorSDK,
  appToken: string,
) => {
  const formComponentSpecs = await sdk.document.tpa.app.getAllComps(
    appToken,
    FORM_APP_DEF_ID,
  );

  const formComponents = await Promise.all(
    formComponentSpecs.map(async (componentClientSpec) => {
      return sdk.components.getById(appToken, {
        id: componentClientSpec?.id,
      });
    }),
  );

  const components = await Promise.all(
    formComponents.map(async (component) => {
      const config = await readConfig({
        sdk,
        appToken,
        component,
      });
      return {
        component,
        ...config,
      };
    }),
  );

  return components.filter((component) => {
    const formAlreadyConfigured = Boolean(component.formId);
    const needsConfiguration =
      component.presetId !== FormAppPreset.Blank &&
      component.presetId !== FormAppPreset.Existing;

    return !formAlreadyConfigured && needsConfiguration;
  });
};
